import React from "react";
import { ArrowRight, Crown, Check } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

const TierCard = ({ tier, onJoin }) => {
  const { t } = useI18n();
  return (
  <div
    className={`rounded-2xl p-8 flex flex-col ${
      tier.highlight ? "bg-white text-[#0a2540] shadow-2xl md:-translate-y-3" : "bg-white/5 border border-white/10"
    }`}
  >
    {tier.highlight && (
      <span className="self-start inline-flex items-center gap-1 bg-[#c9a227] text-white text-[10px] font-700 uppercase tracking-wider px-2.5 py-1 rounded mb-4">
        <Crown className="w-3 h-3" /> {t("mostPopular")}
      </span>
    )}
    <h3 className={`font-display font-800 text-xl ${tier.highlight ? "text-[#0a2540]" : "text-white"}`}>
      {tier.name}
    </h3>
    <div className="mt-3 flex items-end gap-1">
      <span className="font-display font-800 text-4xl">{tier.price}</span>
      <span className={`mb-1 text-sm ${tier.highlight ? "text-slate-500" : "text-slate-300"}`}>
        {tier.cadence}
      </span>
    </div>
    <ul className="mt-6 space-y-3 flex-1">
      {tier.features.map((f) => (
        <li key={f} className="flex items-start gap-2.5 text-[15px]">
          <Check className={`w-4 h-4 mt-1 shrink-0 ${tier.highlight ? "text-[#0a6ed1]" : "text-[#5eb0f5]"}`} />
          <span className={tier.highlight ? "text-slate-600" : "text-slate-200"}>{f}</span>
        </li>
      ))}
    </ul>
    <button
      onClick={() => onJoin(tier)}
      className={`mt-8 w-full inline-flex items-center justify-center gap-2 font-600 px-6 py-3 rounded-full transition-colors ${
        tier.highlight ? "bg-[#0a2540] hover:bg-[#16355c] text-white" : "bg-white text-[#0a2540] hover:bg-slate-100"
      }`}
    >
      {tier.price === "Custom" ? t("talkToUs") : t("joinNow")} <ArrowRight className="w-4 h-4" />
    </button>
  </div>
  );
};

export default TierCard;
